module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-bg-1-2415383db576f5b37176d7c1fa4b0cd1.png";